// // import React, { useEffect } from "react";
// // import BaseReportPage from "./_BaseReportPage";
// // import api from "../../../../api/axios";
// // import { set } from "date-fns";

// // const columns = [
// //   { title: "Employee Code", key: "employee_code" },
// //   { title: "Employee Name", key: "name" },
// //   { title: "Department", key: "department" },
// //   { title: "Leave Type", key: "leave_type" },
// //   { title: "From Date", key: "from_date" },
// //   { title: "To Date", key: "to_date" },
// //   { title: "Duration", key: "duration" },
// //   {
// //     title: "Remark",
// //     key: "remark",
// //     render: (v, row) => row.remark_groups?.leave || "-",
// //   },
// // ];

// // export default function LeaveReportPage() {

// //   return (
// //     <BaseReportPage
// //       // apiEndpoint="/hrms/attendance?only=leave"
// //       apiEndpoint="/hrms/leaves"
// //       columns={columns}
// //       title="Leave Report"
// //       emptyMessage="No leave records for selected range"
// //     />
// //   );
// // }

// import React, { useEffect, useState } from "react";
// import BaseReportPage from "./_BaseReportPage";
// import api from "../../../../api/axios";
// import ReportTable from "../Components/ReportTable";

// export default function LeaveReportPage() {
//   const [allLeaves, setAllLeaves] = useState([]);

//   // Load ALL leaves one time only
//   useEffect(() => {
//     api.get("/hrms/leaves").then((r) => {
//       setAllLeaves(r.data.data);
//     });
//   }, []);

//   // Filtering logic
//   const filterLeaves = (leaves, filters) => {
//     const type = filters.type;

//     if (type === "daily") {
//       return leaves.filter(
//         (l) => filters.date >= l.from_date && filters.date <= l.to_date
//       );
//     }

//     if (type === "range") {
//       return leaves.filter(
//         (l) => !(l.to_date < filters.from_date || l.from_date > filters.to_date)
//       );
//     }

//     if (type === "monthly") {
//       const month = filters.month; // YYYY-MM
//       return leaves.filter(
//         (l) => l.from_date.startsWith(month) || l.to_date.startsWith(month)
//       );
//     }

//     return leaves;
//   };

//   const columns = [
//     {
//       title: "Employee Code",
//       render: (row) => row.employee?.employee_code,
//     },
//     {
//       title: "Employee Name",
//       render: (row) => row.employee?.first_name + " " + row.employee?.last_name,
//     },
//     {
//       title: "Department",
//       render: (row) => row.employee?.department,
//     },
//     {
//       title: "Leave Type",
//       render: (row) => row.type?.name,
//     },
//     { title: "From Date", key: "from_date" },
//     { title: "To Date", key: "to_date" },
//     { title: "Duration", key: "duration_unit" },
//     { title: "Remarks", key: "remarks" },
//     { title: "Status", key: "status" },
//   ];

//   return (
//     <BaseReportPage
//       apiEndpoint="/hrms/leaves" // base but not used for filtering
//       title="Leave Report"
//       columns={columns}
//       emptyMessage="No leave records"
//     />
//   );
// }

import React from "react";
import BaseReportPage from "./_BaseReportPage";

export default function LeaveReportPage() {
  const columns = [
    {
      title: "Employee Code",
      render: (v,row) => row.employee?.employee_code || "-",
    },
    {
      title: "Employee Name",
      render: (v,row) =>
        row.employee
          ? row.employee.first_name + " " + row.employee?.last_name
          : "-",
    },
    {
      title: "Department",
      render: (v,row) => row.employee?.department,
    },
    { title: "Leave Type", render: (v,row) => row.type?.name || "-" },
    { title: "From Date", key: "from_date" },
    { title: "To Date", key: "to_date" },
    { title: "Duration", key: "duration_unit" },
    { title: "Remarks", key: "remarks" },
    { title: "Status", key: "status" },
  ];

  return (
    <BaseReportPage
      apiEndpoint="/hrms/leaves"
      columns={columns}
      title="Leave Report"
      emptyMessage="No leave records"
      downloadEndpoint="/hrms/leaves/download"
    />
  );
}
